module.exports = __webpack_public_path__ + "assets/b3ce4cc5821eedbe8baed02442863801.png";